import React, { useEffect, useState } from 'react'
import { SubmitButton, SuccessMessage, ErrorMessage } from './Components'

const SubmitButtonComponent = ({ success, isSubmitting, errors, touched }) => {
  const errorMessage = errors?.sections
    ?.map((err, index) => {
      if (err && touched?.sections?.[index]) {
        return ` Section ${index + 1}`
      }
      return ''
    })
    .filter((i) => i)
    .join(', ')

  const [showSuccess, setShowSuccess] = useState(false)

  useEffect(() => {
    errorMessage && setShowSuccess(false)
  }, [errorMessage])

  useEffect(() => {
    setShowSuccess(success)
  }, [success])

  return (
    <div className='submit-box'>
      <SubmitButton type='submit' className='btn' processing={isSubmitting}>
        Submit
      </SubmitButton>

      {errorMessage ? (
        <ErrorMessage>Error in {errorMessage} !</ErrorMessage>
      ) : (
        showSuccess && (
          <SuccessMessage>Successfully saved updates!</SuccessMessage>
        )
      )}
    </div>
  )
}

export default SubmitButtonComponent
